import { RolloverSharesClassShareholderResult } from './rollover-shares-class-shareholder.result';
import { IsBoolean, IsInt, IsNotEmpty, IsNumber, IsString } from '@pristine-ts/class-validator';
import { ErrorMessageBuilder } from '../../../../../../common/src/builders/error-message.builder';

export class RolloverPreferredSharesClassResult {

  //From RolloverSharesClassOptions
  // StringType
  @IsString({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  id: string;

  // StringType
  @IsString({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  title: string;

  // BooleanType
  @IsBoolean({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  isRightToResidual: boolean;

  // BooleanType
  @IsBoolean({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  isRightToVote: boolean;

  // BooleanType
  @IsBoolean({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  isRightToParticipate: boolean;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  redemptionValue: number;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  totalPaidUpCapitalBeforeIssuance: number = 0;

  // NumberType
  @IsNumber(undefined, { buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  numberOfSharesBeforeIssuance: number = 0;

  //From RolloverPropertyTransferredSharesClassOptions
  // NumberType
  @IsNumber(undefined, { buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  numberOfShares: number = 0;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  totalFairMarketValue: number = 0;

  //From Rollover
  shareholders: RolloverSharesClassShareholderResult[] = [];

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  totalAdjustedCostBase: number = 0;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  totalPaidUpCapital: number = 0;

  // MoneyType
  @IsInt({ buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  totalPaidUpCapitalIncludingAfterIssuance: number;

  // NumberType
  @IsNumber(undefined, { buildErrorMessage: ErrorMessageBuilder.build })
  @IsNotEmpty({ buildErrorMessage: ErrorMessageBuilder.build })
  numberOfSharesAfterIssuance: number;
}